<ng-container [ngSwitch]="readonly">
  <span *ngSwitchCase="true">{{ selectedDayLabels || "-" }}</span>

  <div *ngSwitchDefault class="flex flex-row gap-x-1">
    <lxm-button
      *ngFor="let day of days"
      [type]="isSelected(day) ? 'beige' : 'white'"
      [width]="'var(--small)'"
      [height]="'var(--small)'"
      (click)="toggleDay(day)"
    >
      {{ getDayShortLabel(day) }}
    </lxm-button>
  </div>
</ng-container>

